import React, { Component } from 'react';
import { connect } from 'react-redux'
import { logOut } from '../Actions/Login'
import { Link } from 'react-router-dom'

import AppStack from './AppStack'

class Oops extends Component {

	constructor(props){

       super(props);

    }

	render(){

		return (

			<AppStack className="basic">

				<section className="wysiwyg">

				<div className="container">

					<div className="page-title-container"><div className="page-title"><h1>Nothing to see here...</h1></div></div>

					<div className="body">
						<p>Maybe check my <a href="https://instagram.com/pauljosephcox" target="_blank">instagram</a></p>
					</div>

					</div>

				</section>

			</AppStack>
		);

	}

}



const mapStateToProps = (state) => {
	return { user: state.User };
}
const mapDispatchToProps = (dispatch) => {
	return {
		onLogout:() => { dispatch(logOut())}
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(Oops)



// WEBPACK FOOTER //
// ./src/Components/Oops.js